import React, { useState } from 'react';
import { Employee } from '../../types';
import './EditEmployeeModal.css';

interface EditEmployeeModalProps {
  employee: Employee;
  onClose: () => void;
  onSave: (employee: Employee) => void;
}

const EditEmployeeModal: React.FC<EditEmployeeModalProps> = ({ employee, onClose, onSave }) => {
  const [formData, setFormData] = useState<Employee>({ ...employee });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({
      ...formData,
      intranet_id: formData.intranet_id?.trim() || null
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="edit-employee-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Edit Employee</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name (First Last)</label>
            <input
              type="text"
              value={formData.name}
              onChange={e => setFormData({ ...formData, name: e.target.value })}
              placeholder="e.g., John Smith"
              required
            />
          </div>
          <div className="form-group">
            <label>Department</label>
            <input
              type="text"
              value={formData.department || ''}
              onChange={e => setFormData({ ...formData, department: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Points</label>
            <input
              type="number"
              value={formData.points}
              onChange={e => setFormData({ ...formData, points: parseInt(e.target.value) || 0 })}
            />
          </div>
          <div className="form-group">
            <label>Intranet Employee ID</label>
            <input
              type="text"
              value={formData.intranet_id || ''}
              onChange={e => setFormData({ ...formData, intranet_id: e.target.value })}
              placeholder="Optional, e.g., 249"
            />
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEmployeeModal;

